import { useEffect, useState } from "react";

export function useWindowSize(breakpoint = 768) {
  const [isSize, setIsSize] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSize(window.innerWidth <= breakpoint);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [breakpoint]);

  return isSize;
}
